// Magic-of-the-night sparkles that rise out of a CTA when the user hovers it.
// Uses pure CSS (animation triggered by .group:hover) so there's no re-render cost.

const SPARKLE_PATH =
  "M12 1.5l1.7 6.6L20.5 10l-6.8 1.9L12 18.5l-1.7-6.6L3.5 10l6.8-1.9L12 1.5z";

function Spark({ pos, tiny }) {
  return (
    <span className={`magic-spark ${pos} ${tiny ? "tiny" : ""}`}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d={SPARKLE_PATH} fill="currentColor" />
      </svg>
    </span>
  );
}

export default function MagicSparkles() {
  return (
    <>
      <Spark pos="s1" />
      <Spark pos="s2" tiny />
      <Spark pos="s3" />
      <Spark pos="s4" tiny />
      <Spark pos="s5" />
      <Spark pos="s6" tiny />
    </>
  );
}
